import { render, staticRenderFns } from "./TableDropshipper.vue?vue&type=template&id=7f2bb46e&"
import script from "./TableDropshipper.vue?vue&type=script&lang=js&"
export * from "./TableDropshipper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports